import { createSelector } from '@reduxjs/toolkit';
import { Store } from 'components/common/types/Store.types';

export const getCampaignStatus = createSelector(
  (state: Store) => state.dealManagement.commonDeal.campaignStatus,
  (campaignStatus) => campaignStatus,
);
